<template>
  <div v-if="quoteProperties && totals">
    <v-alert :value="true" type="info">
      <span style="font-size: 23pt">
        {{ quoteProperties.quotation15 }}
        {{ totals.totalWithVat | toCurrency }}
      </span>
      {{ quoteProperties.quotation16 }}
      {{ quoteProperties.quotation17 }}
    </v-alert>
    <table style="border-collapse: initial">
      <template v-for="section in quote.quoteSections">
        <tr
          :key="`searchesSpacer${section.id}`"
          v-if="section.name == 'searches'"
        >
          <td colspan="3" class="quoteCell">
            <hr />
          </td>
        </tr>
        <template v-for="subSection in section.quoteSubSections">
          <!-- TITLE -->
          <template v-if="subSection.title">
            <tr :key="subSection.id">
              <td colspan="3" class="quoteCell">
                <div v-if="subSection.title.id != itemid">
                  <div style="float: right">
                    <v-btn
                      @click="addItem(section, subSection)"
                      color="info"
                      small
                    >
                      <v-icon>add</v-icon>Item
                    </v-btn>
                  </div>
                  <strong>
                    <span v-if="subSection.title.description">{{
                      subSection.title.description.body
                    }}</span>
                    <span v-if="!subSection.title.description">{{
                      subSection.title.descriptionid
                    }}</span>
                  </strong>
                  <template v-if="subSection.title.value > 0">
                    <span>&#160;</span>
                    <span v-if="subSection.title.secondary">{{
                      subSection.title.secondary.body
                    }}</span>
                    <span v-if="!subSection.title.secondary">{{
                      subSection.title.secondaryid
                    }}</span>
                    <span>&#160;</span>
                    <a @click="selectItem(subSection.title)">{{
                      subSection.title.value | toCurrency
                    }}</a>
                  </template>
                </div>
                <div v-if="subSection.title.id == itemid">
                  <div class="ajaxForm">
                    <v-text-field
                      label="Description"
                      v-model="subSection.title.description.body"
                      readonly
                    />
                    <v-text-field
                      label="Secondary"
                      v-model="subSection.title.secondary.body"
                      readonly
                    />
                    <v-text-field
                      type="number"
                      label="Amount"
                      v-model="itemCopy.value"
                      outline
                    />
                    <v-btn
                      @click="updateTitle(section, subSection)"
                      color="info"
                    >
                      <v-icon>save</v-icon>Save
                    </v-btn>
                    <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <template v-for="item in subSection.quoteItems">
            <!-- ITEM -->
            <template v-if="item.description && item.description.type == 1">
              <tr :key="`itemNote${item.id}`">
                <td colspan="3" class="quoteCell">
                  {{ item.description.body }}
                </td>
              </tr>
            </template>
            <template v-else>
              <tr
                v-if="item.id != itemid"
                :class="item.description ? '' : 'quoteLineThrough'"
                :key="`item${item.id}`"
              >
                <td class="quoteCell quoteLeftSpacer" />
                <td class="quoteCell">
                  <a @click="selectItem(item)">
                    <span v-if="item.description">{{
                      item.description.body
                    }}</span>
                    <span v-if="!item.description">Not set</span>
                  </a>
                  <span>&#160;</span>
                  <span v-if="item.secondary" class="quoteFade">{{
                    item.secondary.body
                  }}</span>
                  <!-- <span v-if="!item.secondary" class="quoteFade">{{item.secondaryid}}</span> -->
                </td>
                <td class="quoteCell quoteNumber">
                  {{ item.value | toCurrency }}
                </td>
              </tr>
              <tr v-if="item.id == itemid" :key="`itemSelected${item.id}`">
                <td class="quoteCell quoteLeftSpacer" />
                <td colspan="2">
                  <div class="ajaxForm">
                    <v-text-field
                      v-if="item.description"
                      label="Description"
                      v-model="item.description.body"
                      readonly
                      outline
                    />
                    <v-select
                      v-if="!item.description"
                      :items="descriptions"
                      v-model="itemCopy.descriptionid"
                      item-text="body"
                      item-value="id"
                      label="Description"
                      outline
                    ></v-select>
                    <v-combobox
                      v-model="itemCopy.secondary"
                      :items="secondaries"
                      label="Secondary"
                      no-filter
                      @input.native="completeSecondary($event.srcElement.value)"
                      outline
                    />
                    <v-text-field
                      type="number"
                      step=".1"
                      label="Amount"
                      v-model="itemCopy.value"
                      outline
                    />
                    <v-btn
                      @click="updateItem(section, subSection, item)"
                      color="info"
                    >
                      <v-icon>save</v-icon>Save
                    </v-btn>
                    <v-btn
                      @click="deleteItem(section, subSection, item)"
                      color="error"
                    >
                      <v-icon>remove</v-icon>Delete
                    </v-btn>
                    <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </template>
        <template v-if="section.name == 'costs'">
          <!-- SALE AND PURCHASE DISCOUNT -->
          <template v-if="quote.quotetypeid == 3">
            <tr
              v-if="selectedQuoteElement != 1"
              :class="`quoteDiscount ${
                quoteBean.quote.spdiscount > 0 ? '' : 'quoteLineThrough'
              }`"
              :key="`spdiscount${section.id}`"
            >
              <td class="quoteCell quoteLeftSpacer" />
              <td class="quoteCell">
                <a class="quoteDiscount" @click="selectQuoteElement(1)">{{
                  quoteProperties.quotation8
                }}</a>
              </td>
              <td class="quoteCell quoteNumber">
                {{ quote.spdiscount | toCurrency }}
              </td>
            </tr>
            <tr
              v-if="selectedQuoteElement == 1"
              :key="`spdiscountSelected${section.id}`"
            >
              <td class="quoteCell quoteLeftSpacer" />
              <td colspan="2">
                <div class="ajaxForm">
                  <v-text-field
                    label="Sale and Purchase discount"
                    v-model="spdiscount"
                  />
                  <v-btn @click="updateSpdiscount">
                    <v-icon>save</v-icon>Save
                  </v-btn>
                  <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- DISCOUNT -->
          <tr
            v-if="selectedQuoteElement != 2"
            :class="`quoteDiscount ${
              quote.discount > 0 ? '' : 'quoteLineThrough'
            }`"
            :key="`discount${section.id}`"
          >
            <td class="quoteCell quoteLeftSpacer" />
            <td class="quoteCell">
              <a class="quoteDiscount" @click="selectQuoteElement(2)">{{
                quoteProperties.quotation9
              }}</a>
              <span>{{ quoteProperties.quotation18 }}</span>
              <span>{{ quote.discount }}</span>
              <span>%</span>
            </td>
            <td class="quoteCell quoteNumber">
              {{ totals.costsDiscount | toCurrency }}
            </td>
          </tr>
          <tr
            v-if="selectedQuoteElement == 2"
            :key="`discountSelected${section.id}`"
          >
            <td class="quoteCell quoteLeftSpacer" />
            <td colspan="2">
              <div class="ajaxForm">
                <v-text-field label="Discount" v-model="discount" />
                <div>{{ totals.costsDiscount }}</div>
                <v-btn @click="updateDiscount">
                  <v-icon>save</v-icon>Save
                </v-btn>
                <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
              </div>
            </td>
          </tr>
          <!-- VAT -->
          <tr
            class="quoteFade"
            v-if="selectedQuoteElement != 3"
            :key="`vat${section.id}`"
          >
            <td class="quoteCell quoteLeftSpacer" />
            <td class="quoteCell">
              <a class="quoteFade" @click="selectQuoteElement(3)"
                >VAT calculated</a
              >
              <span>{{ quoteProperties.quotation18 }}</span>
              <span>{{ quote.vatrate }}</span>
              <span>%</span>
            </td>
            <td class="quoteCell quoteNumber">
              {{ totals.costsVat | toCurrency }}
            </td>
          </tr>
          <tr
            v-if="selectedQuoteElement == 3"
            :key="`vatSelected${section.id}`"
          >
            <td class="quoteCell quoteLeftSpacer" />
            <td colspan="2">
              <div class="ajaxForm">
                <v-text-field label="Vat rate" v-model="vatrate" />
                <span>{{ totals.costsVat }}</span>
                <v-btn @click="updateVatrate">
                  <v-icon>save</v-icon>Save
                </v-btn>
                <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
              </div>
            </td>
          </tr>
          <tr :key="`totalWithVat${section.id}`">
            <td colspan="2" class="quoteCell quoteBold">
              {{ quoteProperties.quotation11 }}
            </td>
            <td class="quoteCell quoteNumber quoteBold">
              {{ totals.totalWithVat | toCurrency }}
            </td>
          </tr>
          <tr :key="`costSpacer${section.id}`">
            <td colspan="3" class="quoteCell">
              <hr />
            </td>
          </tr>
        </template>
        <template v-if="section.name == 'disbursements'">
          <tr :key="`disbursementsTotal${section.id}`">
            <td colspan="2" class="quoteCell quoteBold">
              {{ quoteProperties.quotation12 }}
            </td>
            <td class="quoteCell quoteNumber quoteBold">
              {{ totals.totalDisbursements | toCurrency }}
            </td>
          </tr>
          <tr :key="`disbursementsSpacer${section.id}`">
            <td colspan="3" class="quoteCell">
              <hr />
            </td>
          </tr>
          <tr :key="`totalWithVatDisbursements${section.id}`">
            <td colspan="2" class="quoteCell quoteSummary quoteBold">
              {{ quoteProperties.quotation13 }}
            </td>
            <td class="quoteCell quoteNumber quoteSummary quoteBold">
              {{ totals.totalWithVatDisbursements | toCurrency }}
            </td>
          </tr>
        </template>
        <template v-if="section.name == 'searches'">
          <tr :key="`searchesTotal${section.id}`">
            <td colspan="2" class="quoteCell quoteBold">
              {{ quoteProperties.quotation14 }}
            </td>
            <td class="quoteCell quoteNumber quoteBold">
              {{ totals.totalSearches | toCurrency }}
            </td>
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="3" class="quoteCell">
          <hr />
          <div>
            <strong>Note</strong>
          </div>
          <div v-if="selectedQuoteElement != 4">
            <span v-if="!quote.noteCosts">Not set</span>
            <span v-if="quote.noteCosts" style="white-space: pre-wrap">{{
              quote.noteCosts
            }}</span>
            <br />
            <v-btn
              class="quoteFade"
              @click="selectQuoteElement(4)"
              color="info"
              small
            >
              <v-icon>edit</v-icon>Edit
            </v-btn>
          </div>
          <div v-if="selectedQuoteElement == 4" class="ajaxForm">
            <v-textarea outline label="Note" v-model="noteCosts" />
            <v-btn @click="updateNote"> <v-icon>save</v-icon>Save </v-btn>
            <v-btn @click="cancel"> <v-icon>undo</v-icon>Cancel </v-btn>
          </div>
        </td>
      </tr>
      <tr v-if="additional" id="quoteAdditional">
        <td colspan="3" class="quoteCell" v-html="additional" />
      </tr>
    </table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Quotation",
  props: ["quote", "lastUpdated", "selectedHeaderElement"],
  data() {
    return {
      sections: null,
      subSections: null,
      titles: null,
      items: null,
      titleDescriptions: null,
      titleSecondaries: null,
      itemDescriptions: null,
      itemSecondaries: null,
      descriptions: [],
      secondaries: [],
      quoteProperties: null,
      totals: null,
      additional: null,
      itemid: null,
      itemCopy: null,
      vatrate: null,
      selectedQuoteElement: 0,
      discount: null,
      spdiscount: null,
      noteCosts: null,
      timerId: null
    };
  },
  methods: {
    async fetchDescriptions() {
      const response = await nbmlaw.get(`/cors/admin/sales/descriptions`, {
        params: { type: 0 }
      });
      // console.log(response.data)
      this.descriptions = response.data;
    },
    async fetchQuoteProperties() {
      const response = await nbmlaw.get(`/cors/open/sales/quoteProperties`);
      // console.log(response.data);
      this.quoteProperties = response.data;
    },
    async fetchTotals() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}/totals`
      );
      // console.log(response.data);
      this.totals = response.data;
    },
    async fetchAdditional() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}/additional/html`
      );
      // console.log(response.data);
      this.additional = response.data;
    },
    async addItem(section, subSection) {
      await nbmlaw.post(
        `/cors/admin/sales/quotes/${this.$route.params.id}/sections/${section.id}/subSections/${subSection.id}/items`,
        null
      );
      // console.log(response.data);
      this.cancel();
    },
    async updateDiscount() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/discount`,
        {
          value: this.discount
        }
      );
      // console.log(response.data);
      this.cancel();
    },
    async updateSpdiscount() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/spdiscount`,
        {
          value: this.spdiscount
        }
      );
      // console.log(response.data);
      this.cancel();
    },
    async updateVatrate() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/vatrate`,
        {
          value: this.vatrate
        }
      );
      // console.log(response.data);
      this.cancel();
    },
    async updateNote() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/note`,
        {
          value: this.noteCosts
        }
      );
      // console.log(response.data);
      this.cancel();
    },
    selectItem(item) {
      this.itemid = item.id;
      this.itemCopy = {
        descriptionid: item.descriptionid,
        secondary: item.secondary ? item.secondary.body : undefined,
        value: item.value
      };
    },
    async deleteItem(section, subSection, item) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/sales/quotes/${this.$route.params.id}/sections/${section.id}/subSections/${subSection.id}/items/${item.id}`
        );
        // console.log(response.data);
        this.cancel();
      }
    },
    async updateTitle(section, subSection) {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/sections/${section.id}/subSections/${subSection.id}/title`,
        this.itemCopy
      );
      // console.log(response.data);
      this.cancel();
    },
    async updateItem(section, subSection, item) {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/sections/${section.id}/subSections/${subSection.id}/items/${item.id}`,
        this.itemCopy
      );
      // console.log(response.data);
      this.cancel();
    },
    selectQuoteElement(value) {
      this.cancel();
      this.selectedQuoteElement = value;
      this.discount = this.quote.discount;
      this.spdiscount = this.quote.spdiscount;
      this.vatrate = this.quote.vatrate;
      this.noteCosts = this.quote.noteCosts;
    },
    cancel() {
      this.itemid = null;
      this.$emit("changeSelectedHeaderElement", 0);
      this.selectedQuoteElement = 0;
    },
    completeSecondary(value) {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // console.log(value)
        if (value) {
          this.fetchSecondaries(value);
        }
      }, 500);
    },
    async fetchSecondaries(value) {
      const response = await nbmlaw.get(
        `/cors/admin/sales/secondaries/complete/body`,
        {
          params: { value }
        }
      );
      // console.log(response.data)
      this.secondaries = response.data;
    },
    fetchAll() {
      this.fetchQuoteProperties();
      this.fetchTotals();
      this.fetchDescriptions();
      this.fetchAdditional();
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    }
  }
};
</script>

<style >
.quoteTypeHidden {
  color: red;
}

.quoteTypeVisible {
  color: green;
}

.quoteLeftSpacer {
  width: 5%;
}

.quoteCell {
  border: none;
  padding: 2px;
}

.quoteDiscount {
  color: green;
}

.quoteFade {
  color: gray;
}

.quoteBold {
  font-weight: bold;
}

.quoteLineThrough {
  text-decoration: line-through;
}

.quoteNumber {
  text-align: right;
}

.quoteSummary {
  font-size: 1.2em;
}

.quoteMainTotal {
  padding: 5px;
  margin-bottom: 5px;
  background: #6699cc;
  color: white;
}
</style>